import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-developer-guide',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  templateUrl: './developer-guide.component.html',
  styleUrls: ['./developer-guide.component.scss']
})
export class DeveloperGuideComponent implements OnInit {
  
  markdownContent = '';
  isLoading = true;
  
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.loadMarkdownContent();
  }

  private async loadMarkdownContent(): Promise<void> {
    try {
      const markdownText = await firstValueFrom(this.http.get(`${environment.docsBaseUrl}/developer-guide.md`, { responseType: 'text' }));
      
      if (markdownText) {
        this.markdownContent = markdownText;
      }
    } catch (error) {
      console.error('Error loading markdown content:', error);
      this.markdownContent = '# Error\n\nError loading developer guide content.';
    } finally {
      this.isLoading = false;
    }
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Code copied to clipboard!');
      // You could add a toast notification here
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }
}
